export default __webpack_public_path__ + "static/media/web_dev.20fed85d.jpg";